import { GetterTree } from 'vuex';
import { RootState } from '../store';
import { ISettingsBillingState } from '../stores/settings-billing.store';
import { getPlanPricing } from '@/common/plans';

export const getterTotalPrice = 'totalPrice';

export const getters: GetterTree<ISettingsBillingState, RootState> = {
  [getterTotalPrice]: (state: ISettingsBillingState): number => {
    if (state.isLoading) {
      return 0;
    }
    return (
      state.userCount *
      state.plan.paymentFrequency.months *
      getPlanPricing(state.planType, state.plan.paymentFrequency.key, state.billingCurrency)
    );
  },
};
